"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSanitizedHTML = void 0;
var _react = require("react");
var _sanitizeHtmlReact = _interopRequireDefault(require("sanitize-html-react"));
var useSanitizedHTML = function useSanitizedHTML(html) {
  var sanitizedHtml = (0, _react.useMemo)(function () {
    return html && (0, _sanitizeHtmlReact.default)(html, {
      allowedTags: ['a'],
      allowedAttributes: {
        a: ['href', 'target']
      }
    });
  }, [html]);
  return sanitizedHtml;
};
exports.useSanitizedHTML = useSanitizedHTML;